export default __webpack_public_path__ + "static/media/Miter of the Riftcaller.b078f316.jpg";